import React from 'react';
import { connect } from "react-redux";
import { useParams, useHistory, Redirect } from "react-router-dom";
import { Tab, Tabs } from 'react-bootstrap';
import ProfileBanner from './profile_sections/profile_banner';
import ActivityList from './profile_sections/activity_list';
import Statistics from './profile_sections/statistics';

const TABS = ['activities', 'performance'];
const DEFAULT_TAB = 'activities';

function UserProfileShow(props) {
  const { user_id, tab } = useParams();
  const history = useHistory();

  if (!tab || !TABS.includes(tab)) {
    return <Redirect to={`/user-profiles/${user_id}/${DEFAULT_TAB}`} />;
  }

  const handleSelect = (key) => {
    if (key && key !== tab) {
      history.push(`/user-profiles/${user_id}/${key}`);
    }
  };

  return (
    <div className="activity-page_container container p-0 my-1">
      <ProfileBanner />
      <Tabs
        activeKey={tab}
        onSelect={handleSelect}
        id="userProfileNav"
        className="user_profile-tabs"
      >
        <Tab eventKey="activities" title="Activities">
          <ActivityList />
        </Tab>
        <Tab eventKey="performance" title="Performance">
          <Statistics />
        </Tab>
      </Tabs>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
  };
};

export default connect(mapStateToProps, {})(UserProfileShow);
